import { Group } from '../models';
import { ApiService } from './ApiService';
import apiResponse from './ApiResponse';
import { GroupView } from '../views/GroupView';

export class GroupStore {
  constructor(
    private readonly api: ApiService = new ApiService(),
    // Saving a team isn't safe to repeat: a retry after a timeout races the original request and can
    // create the team or its participants twice, so team writes are sent exactly once
    private readonly writeApi: ApiService = new ApiService(undefined, undefined, { maxRetries: 0 })
  ) {}

  public async InvalidateCache() {
    try {
      const result = await this.api.post('admin/cohort/invalidateCache', {});
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async SendCustomGoodyGift(cohortUserId: number, amount: number, message?: string) {
    try {
      const result = await this.api.post('admin/cohort/customGoodyPrize', {
        cohortUserId: cohortUserId,
        amount: amount,
        message: message,
      });
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async ReadOne(groupId: number) {
    try {
      const result = await this.api.get(`Cohort/${groupId}`);
      return apiResponse.Success<Group>(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async ReadAll() {
    try {
      const response = await this.api.get('Cohort');
      // await sleep(2000);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async AdminReadAll() {
    try {
      const response = await this.api.get('admin/Cohort');
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async Write(selectedGroup: GroupView) {
    try {
      const response = await this.writeApi.post('cohort', selectedGroup);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async Update(group: Group) {
    try {
      const response = await this.writeApi.put('cohort', group);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async Delete(group: Group) {
    try {
      const response = await this.api.delete(`/cohort/${group.id}`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async FinalizeCohort(groupId: number) {
    try {
      const response = await this.api.post(`/admin/cohort/finalize/${groupId}`, {});
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async AdminGetCohortReportCard(groupId: number) {
    try {
      const response = await this.api.get(`/admin/cohort/reportCard/${groupId}`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async AdminGetEngagementReport(groupId: number) {
    try {
      const response = await this.api.get(`/admin/cohort/${groupId}/engagementReport`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async AdminGetPrizeDrawings(groupId: number) {
    try {
      const response = await this.api.get(`/admin/cohort/${groupId}/prizeDrawings`);
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async AdminGetRiskReport() {
    try {
      const response = await this.api.get('/admin/cohort/reports/risk');
      return apiResponse.Success(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
